<template>
    <div class="text-center" v-if="generating">
        <i class="icon-spinner6 spinner mr-2"></i>{{ $t('aiGeneration.loading.waitingForResponse') }}<span class="dots">.</span>
    </div>
    <NavTab class="nav-tabs-highlight" v-else>
        <NavTabItem
            v-for="(language, index) in integrationLanguages"
            :key="language"
            :ref="el => languageRefs[index] = el"
            :href="`#generate-modal-${language}`"
        >
            {{ $t(`languages.${language}`) }}
        </NavTabItem>
        <template #content>
            <NavTabPane v-for="language in integrationLanguages" :id="`generate-modal-${language}`">
                <div class="row">
                    <div class="col-lg-6">
                        <AppFieldset :title="$t('aiGeneration.review.old')">
                            <FormGroup :label="$t('aiGeneration.fields.name')" v-if="Object.values(generatedContent.names).length">
                                <Input
                                    :model-value="product.names[language]"
                                    :readonly="true"
                                />
                            </FormGroup>
                            <FormGroup :label="$t('aiGeneration.fields.seo')" v-if="Object.values(generatedContent.seos).length">
                                <Tags
                                    :model-value="product.seos[language]"
                                    :disabled="true"
                                />
                            </FormGroup>
                            <FormGroup :label="$t('aiGeneration.fields.description')" v-if="Object.values(generatedContent.descriptions).length">
                                <InputTextArea
                                    :model-value="product.descriptions[language]"
                                    :disabled="true"
                                />
                            </FormGroup>
                        </AppFieldset>
                    </div>
                    <div class="col-lg-6">
                        <AppFieldset :title="$t('aiGeneration.review.new')">
                            <FormGroup :label="$t('aiGeneration.fields.name')" v-if="Object.values(generatedContent.names).length">
                                <Input
                                    v-model="generatedContent.names[language]"
                                    @input="$emit('update:generated-content', generatedContent)"
                                />
                            </FormGroup>
                            <FormGroup :label="$t('aiGeneration.fields.seo')" v-if="Object.values(generatedContent.seos).length">
                                <Tags
                                    v-model="generatedContent.seos[language]"
                                    @input="$emit('update:generated-content', generatedContent)"
                                />
                            </FormGroup>
                            <FormGroup :label="$t('aiGeneration.fields.description')" v-if="Object.values(generatedContent.descriptions).length">
                                <InputTextArea
                                    v-model="generatedContent.descriptions[language]"
                                    @input="$emit('update:generated-content', generatedContent)"
                                />
                            </FormGroup>
                        </AppFieldset>
                    </div>
                </div>
            </NavTabPane>
        </template>
    </NavTab>
</template>
<script>
import NavTab from '../../../../components/tabs/NavTab.vue';
import NavTabItem from '../../../../components/tabs/NavTabItem.vue';
import NavTabPane from '../../../../components/tabs/NavTabPane.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import InputTextArea from '../../../../../components/new/form/InputTextArea.vue';
import Tags from '../../../../../components/new/form/Tags.vue';
import AppFieldset from '../../../../../components/new/AppFieldset.vue';

import GeminiService from '../../../../../services/GeminiService/GeminiService';

export default {
    name: 'FinallyReviewScreen',
    components: {
        NavTab, NavTabItem, NavTabPane, FormGroup, Input, InputTextArea, Tags, AppFieldset
    },
    props: {
        generatedContent: {
            type: Object,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        mainIntegrationLanguage: {
            type: String,
            default: 'en'
        },
        geminiService: {
            type: GeminiService,
            required: true
        },
        integrationLanguages: {
            type: Array,
            default: () => []
        },
        tokenBalance: {
            type: [Number, null],
            default: null
        }
    },
    emits: ['generatingStarted', 'generatingStopped', 'update:generated-content'],
    data() {
        return {
            languageRefs: [],
            generating: true
        }
    },
    methods: {
        async fillAllTranslations() {
            this.$emit('generatingStarted');
            const prompt = this.createPrompt();

            try {
                const response = await this.geminiService.generate(prompt, {
                    temperature: 0.2,
                    topP: 0.95
                });
                
                for (let [field, content] of Object.entries(response)) {
                    this.generatedContent[field] = content;
                }
            } catch (error) {
                console.error(error);
            } finally {
                await this.geminiService.flushTokens(this.$route.params.projectUuid, `Переклад контенту товару ${this.product.names[this.mainIntegrationLanguage] || Object.values(this.product.names)[0] || ''}`);
                this.$emit('tokensFlushed');
            }

            this.generating = false;
            this.$emit('generatingStopped');

            this.$nextTick(() => {
                this.languageRefs[0].click();
            });
        },
        createPrompt() {
            let filteredGeneratedContent = {};

            for (let [field, content] of Object.entries(this.generatedContent)) {
                if (Object.keys(content).length) {
                    filteredGeneratedContent[field] = content;
                }
            }

            return `
                This is Object with content on ${this.mainIntegrationLanguage} language: ${JSON.stringify(filteredGeneratedContent, null, 2)}

                You need to generate another translations for this fields: ${JSON.stringify(this.integrationLanguages.filter(lang => lang !== this.mainIntegrationLanguage).join(', '))}.

                Return JSON Object with available translations and new translations without any additional text or explanations.
            `
        }
    },
    updated() {
        this.languageRefs = []
    },
    mounted() {
        this.fillAllTranslations();
    }
}
</script>